import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'
import { css } from '@linaria/core'

import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import modalBg from '../../assets/common/modal_bg.webp'
import Modal from '../common/modal'
import { numberWithCommas } from '../../utils/number'
import { Link } from '@tanstack/router'

const container = css`
  padding: 85px 50px 40px 65px;
  border-color: none;
  border: none;
  background: url(${modalBg});
  background-size: contain;
  background-repeat: repeat;
  aspect-ratio: 241 / 213;
  width: 360px;
  max-width: unset;
  @media (min-width: 1200px) {
    padding: 140px 70px 40px 85px;
    width: 600px;
  }
`

const Close = styled.button`
  display: flex;
  position: absolute;
  padding: 16px;
  top: 0;
  right: 0;
  &:hover {
    opacity: 0.8;
  }
  @media (min-width: 1200px) {
    padding: 20px;
  }
`

const Message = styled.p`
  font-family: 'Avenir-Light';
  font-size: 12px;
  text-align: center;
  text-shadow: 2px 2px #000;
  color: #fff;
  &.bold {
    font-family: 'Avenir-Heavy';
    text-transform: uppercase;
    font-size: 16px;
    margin-bottom: 6px;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
    &.bold {
      font-size: 24px;
      margin-top: 12px;
    }
  }
`

const Prize = styled.p`
  font-family: 'Avenir-Heavy';
  text-shadow: 2px 2px #d20c69ff;
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 6px;
  text-align: center;
  color: #fff;
  @media (min-width: 1200px) {
    font-size: 66px;
    line-height: 76px;
    margin-bottom: 12px;
  }
`

const ClickHere = styled.button`
  height: 25px;
  background-color: #df0033;
  border-radius: 2px;
  padding: 0 16px;
  margin: 10px auto;
  width: max-content;
  width: 70px;
  p {
    font-size: 10px;
    line-height: 25px;
    color: #fff;
    font-family: 'Syncopate-Bold';
    text-transform: uppercase;
    text-align: center;
  }
  @media (min-width: 1200px) {
    height: 40px;
    width: 100px;
    margin: 24px auto 16px;
    p {
      font-size: 14px;
      line-height: 35px;
    }
  }
`

const Title = styled.h3`
  font-family: 'Syncopate-Bold';
  font-size: 15px;
  line-height: 15px;
  width: 100%;
  font-style: italic;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #f4f4f4ff;
  -webkit-text-stroke-width: 0.7px;
  -webkit-text-stroke-color: #d20c69ff;
  margin: 0 auto 8px;
  @media (min-width: 1200px) {
    font-size: 26px;
    line-height: 30px;
    -webkit-text-stroke-width: 2px;
    margin: 0 auto 6px;
  }
`

const Terms = styled(Link)`
  color: #fff;
  text-decoration: underline;
  font-size: 12px;
  text-align: center;
  width: 100%;
  display: block;
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`

interface CongratsModalProps {
  amount: number
}

const CongratsModal = ({ amount }: CongratsModalProps) => {
  const { t } = useTranslation(['referral', 'common', 'freeBonus', 'homeV2'])
  const modal = useModal()
  return (
    <Modal id="coin-shower-game-congrats" containerStyle={container}>
      <Close onClick={() => closeModal(modal)}>
        <Icon id="close" width="15" height="15" fill="#fff" />
      </Close>
      <Title>{t('congratulations', { ns: 'common' })}</Title>
      <Message className="bold">{t('you-won', { ns: 'freeBonus' })}</Message>
      <Prize>${numberWithCommas(amount)}</Prize>
      <Message>{t('check-amount')}</Message>
      <ClickHere className="flx-ctr" onClick={() => closeModal(modal)}>
        <p>{t('ok', { ns: 'common' })}</p>
      </ClickHere>
      <Terms
        onClick={() => closeModal(modal)}
        to="/vip"
        search={{ tab: 'system', view: 'coin-shower-game-bonus' }}>
        {t('terms', { ns: 'homeV2' })}
      </Terms>
    </Modal>
  )
}

export default NiceModal.create(CongratsModal)
